var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-amap',{staticClass:"amap-demo",attrs:{"vid":_vm.amapVue,"zoom":_vm.zoom,"center":_vm.center}},[_c('el-amap-marker',{attrs:{"position":_vm.center}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363bec98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assembly/amap.vue
// module id = null
// module chunks = 